import { render, staticRenderFns } from "./SettingsAdminPermissions.vue?vue&type=template&id=4bfc5028&"
import script from "./SettingsAdminPermissions.vue?vue&type=script&lang=ts&"
export * from "./SettingsAdminPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bfc5028')) {
      api.createRecord('4bfc5028', component.options)
    } else {
      api.reload('4bfc5028', component.options)
    }
    module.hot.accept("./SettingsAdminPermissions.vue?vue&type=template&id=4bfc5028&", function () {
      api.rerender('4bfc5028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SettingsAdminPermissions.vue"
export default component.exports